/**
 * An object to represent the different stages of the checkout process.
 * Originally these were numeric so, they could be compared, but strings were used instead to match them up to
 * lang strings.
 *
 * If you change these, make sure you update the appropriate CHECKOUT_ language strings too.
 */
const CheckoutStage = {
    CHECK_CONNECTIVITY: 'CHECK_CONNECTIVITY',

    RESERVE_ITEMS: 'RESERVE_ITEMS',

    CREATE_UNCONFIRMED_ORDER: 'CREATE_UNCONFIRMED_ORDER',

    VALIDATE_ORDER: 'VALIDATE_ORDER',

    TAKE_PAYMENT: 'TAKE_PAYMENT',

    // An unconfirmed order will be cancelled if the user cancels payment.
    CANCEL_UNCONFIRMED_ORDER: 'CANCEL_UNCONFIRMED_ORDER',

    SAVE_PAYMENTS: 'SAVE_PAYMENTS',

    CONFIRM_ORDER: 'CONFIRM_ORDER',

    CREATE_CONFIRMED_ORDER: 'CREATE_CONFIRMED_ORDER',

    CONFIRM_ADJUSTMENT: 'CONFIRM_ADJUSTMENT',

    CONFIRM_BALANCE_PAYMENT: 'CONFIRM_BALANCE_PAYMENT',

    // For the Entersoft eInvoicing integration.
    CREATE_INVOICE: 'CREATE_INVOICE',
};

module.exports = CheckoutStage;
